import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { MapPin, Users } from "lucide-react";

// Leaflet é carregado via CDN em public/index.html (window.L) — evita dependência de build.
export default function AlphaMap() {
  const [data, setData] = useState({ total: 0, ranking: [], points: [] });
  const mapRef = useRef(null);
  const mapObj = useRef(null);

  useEffect(() => { api.get("/clients/map").then((r) => setData(r.data)).catch(() => {}); }, []);

  useEffect(() => {
    const L = window.L;
    if (!L || !mapRef.current || mapObj.current) return;
    const m = L.map(mapRef.current, { zoomControl: true }).setView([-15.7942, -47.8822], 11); // Brasília
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap", maxZoom: 19,
    }).addTo(m);
    mapObj.current = m;
  }, []);

  useEffect(() => {
    const L = window.L;
    if (!L || !mapObj.current) return;
    const m = mapObj.current;
    // limpa marcadores anteriores
    m.eachLayer((layer) => { if (layer instanceof L.CircleMarker) m.removeLayer(layer); });
    const latlngs = [];
    data.points.forEach((p) => {
      L.circleMarker([p.lat, p.lng], { radius: 7, color: "#D4AF37", fillColor: "#D4AF37", fillOpacity: 0.7 })
        .addTo(m).bindPopup(`<b>${p.name}</b><br/>${p.neighborhood}<br/><small>Local aproximado por CEP</small>`);
      latlngs.push([p.lat, p.lng]);
    });
    if (latlngs.length > 0) {
      try { m.fitBounds(latlngs, { padding: [40, 40], maxZoom: 14 }); } catch (e) { /* noop */ }
    }
  }, [data.points]);

  return (
    <div className="space-y-6" data-testid="alpha-map-page">
      <div><h1 className="text-3xl font-display font-extrabold tracking-tight text-white">Mapa Alpha</h1>
        <p className="text-zinc-400 mt-1">Distribuição dos clientes por bairro em Brasília · inteligência de território.</p></div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 alpha-card overflow-hidden" style={{ height: 460 }}>
          <div ref={mapRef} data-testid="leaflet-map" style={{ height: "100%", width: "100%", background: "#0C0C10" }} />
        </div>
        <div className="alpha-card p-5">
          <div className="flex items-center gap-2 text-white font-semibold mb-4"><Users size={16} className="text-gold-bright" />{data.total} clientes</div>
          <div className="text-xs uppercase tracking-wider text-zinc-500 mb-2">Ranking por bairro</div>
          <div className="space-y-2 max-h-[360px] overflow-y-auto pr-1">
            {data.ranking.length === 0 && <p className="text-sm text-zinc-600">Sem dados.</p>}
            {data.ranking.map((r) => (
              <div key={r.neighborhood} data-testid={`hood-${r.neighborhood}`} className="flex items-center justify-between text-sm">
                <span className="text-zinc-300 inline-flex items-center gap-2"><MapPin size={12} className="text-gold" />{r.neighborhood}</span>
                <span className="text-gold-bright font-mono-kpi">{r.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
